<script lang="ts">
	// Services
	import { format } from 'svelte-i18n';
	// Design system components
	import { Alert, Button } from '@Shelly/shelly-design-system';
	// Helpers
	import { calibrateDimmerG2 } from 'src/helpers/requests/calibrate_dimmer_g2';
	import { doNotShowInitCalibrationModal } from 'src/stores/ui/calibration-modals';
	import isDimmerWithCalibration from 'src/helpers/is_calibratable_dimmer';

	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	export let device;

	let loading = false;
	let _isDimmerWithCalibration = isDimmerWithCalibration(device.type);

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: handleCalibrate,
				loading,
				disabled: loading,
				label: $format('button_calibrate'),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});

	function handleCalibrate() {
		loading = true;
		//in terms to know from where the calibration is started I add if statement in this component and in the ControlOnOff.svelte
		//do not show init calibration modal if calibration is turned on from the calibration settings
		if (_isDimmerWithCalibration) {
			doNotShowInitCalibrationModal.set(true);
		}
		calibrateDimmerG2(device).then(() => {
			loading = false;
		});
	}

	$: heading =
		device.type === 'SNDC-0D4P10WW'
			? $format('alert_heading_rgbw_light_calibration', {
					default: 'Calibrate Plus RGBW PM',
				})
			: $format('description_dimmer_calibration_header', {
					default: "Calibrate current dimmer's channel.",
				});
	$: message =
		device.type === 'SNDC-0D4P10WW'
			? $format('alert_message_rgbw_light_calibration', {
					default:
						'Note: During calibration, all channels are calibrated one after another. Do not change the device profile of an uncalibrated channel during the process.',
				})
			: $format('description_dimmer_calibration_note', {
					default:
						"Note: During calibration you can't calibrate other channel. During calibration don't change channels states.",
				});
</script>

<Alert class="mb-s" type="info" {heading} {message} />
{#if !$showNewLayout}
	<Button size="m" width="full" {loading} on:click={handleCalibrate}
		>{$format('button_calibrate')}</Button
	>
{/if}
